import debounce from 'lodash/debounce';
import smoothscroll from 'smoothscroll-polyfill';

class BrixModuleSelectedPosts {
  static init(...parameters) {
    return new BrixModuleSelectedPosts(...parameters);
  }

  constructor(selector) {
    this.selector = selector;

    this.scrollWrapper = this.selector.querySelector('.scroll-wrapper');

    if (this.scrollWrapper) {
      this.postsWrapper = this.selector.querySelector('.posts');
      this.allPosts = [...this.postsWrapper.querySelectorAll('.post')];
      this.firstPost = this.postsWrapper.querySelector('.post');
      this.earlierDatesButton = this.selector.querySelector('.scroll-button.-earlier');
      this.laterDatesButton = this.selector.querySelector('.scroll-button.-later');
      this.progressWrapper = this.selector.querySelector('.progress');
      this.currentProgress = this.selector.querySelector('.current-progress');
      this.totalProgress = this.selector.querySelector('.total-progress');
      this.totalPosts = this.allPosts.length;
      const { columnGap, paddingLeft } = getComputedStyle(this.postsWrapper);
      this.postWidth = this.firstPost.offsetWidth + Number(columnGap.split('p')[0]);

      smoothscroll.polyfill();
      this.toggleButtonVisibility();

      if (this.earlierDatesButton) {
        this.earlierDatesButton.addEventListener('click', () => {
          this.postsWrapper.scrollBy({
            top: 0,
            left: -(this.postWidth * (this.scrollWrapper.scrollWidth / this.postWidth) - (Number(paddingLeft.split('p')[0]) * 2 - Number(columnGap.split('p')[0]))),
            behavior: 'smooth',
          });
        });
      }

      if (this.earlierDatesButton) {
        this.laterDatesButton.addEventListener('click', () => {
          this.postsWrapper.scrollBy({
            top: 0,
            left: this.postWidth * (this.scrollWrapper.scrollWidth / this.postWidth) - (Number(paddingLeft.split('p')[0]) * 2 - Number(columnGap.split('p')[0])),
            behavior: 'smooth',
          });
        });
      }

      this.postsWrapper.addEventListener('scroll', debounce(() => {
        this.toggleButtonVisibility();
      }));
    }
  }

  toggleButtonVisibility() {
    if (!this.laterDatesButton.classList.contains('-show')) {
      this.laterDatesButton.classList.add('-show');
    }

    if (!this.earlierDatesButton.classList.contains('-show')) {
      this.earlierDatesButton.classList.add('-show');
    }

    if (this.postsWrapper.scrollLeft === 0) {
      if (this.earlierDatesButton.classList.contains('-show')) {
        this.earlierDatesButton.classList.remove('-show');
      }
    }

    if (this.postsWrapper.scrollWidth - this.postsWrapper.offsetWidth
      === this.postsWrapper.scrollLeft
    ) {
      if (this.laterDatesButton.classList.contains('-show')) {
        this.laterDatesButton.classList.remove('-show');
      }
    }

    const countPostsInView = Math.round(this.scrollWrapper.scrollWidth / this.postWidth).toFixed(1);
    this.totalSlides = Math.ceil(this.totalPosts / Number(countPostsInView));

    if (this.totalSlides > 1 && this.progressWrapper) {
      this.progressWrapper.classList.add('-show');
    }
    if (this.totalSlides < 10) {
      this.totalSlides = `0${this.totalSlides}`;
    }

    this.totalProgress.innerHTML = ` / ${this.totalSlides}`;

    const scrollPercent = this.postsWrapper.scrollLeft / this.postsWrapper.scrollWidth;
    let currentSlide = Math.round(this.totalSlides * scrollPercent) + 1;

    if (currentSlide < 10) {
      currentSlide = `0${currentSlide}`;
    }
    this.currentProgress.innerHTML = currentSlide;
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-selected-posts', BrixModuleSelectedPosts.init);
}
